import { useEffect } from "react";
import { useLocation } from "react-router";
import MarketHero from "../components/simmarkets/MarketHero";
import MarketRail from "../components/simmarkets/MarketRail";
import MarketStory from "../components/simmarkets/MarketStory";
import MarketProduct from "../components/simmarkets/MarketProduct";
import MarketJourney from "../components/simmarkets/MarketJourney";
import MarketClose from "../components/simmarkets/MarketClose";

function SimMarketsPage() {
  const { hash } = useLocation();

  useEffect(() => {
    const id = hash.replace("#", "");
    if (!id) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 160);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <MarketHero />
      <MarketRail />
      <MarketStory />
      <MarketProduct />
      <MarketJourney />
      <MarketClose />
    </>
  );
}

export default SimMarketsPage;
